// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3D_jg","question":"Question_question__3BAZ_","description":"Question_description__3UbVq"};